module.exports = __webpack_public_path__ + "img/face-no1-1.75b0c931.png";